export default "__VITE_ASSET__89613e4a__"